// extracted by mini-css-extract-plugin
export default {"timeline":"style_timeline__6TrEw","duration":"style_duration__vqTsC"};